import { createAction, props } from '@ngrx/store';

import { IFormMode } from '../../types/IFormMode';
import { Provider } from '../../../core/domain/provider/provider';

export const openProviderModal = createAction(
  '[Provider Modal] Open Modal',
  props<{ mode: IFormMode; provider?: Provider }>()
);

export const closeProviderModal = createAction('[Provider Modal] Close Modal');

export const loadProviders = createAction(
  '[Provider] Load Providers',
  props<{ providers: Provider[] }>()
);

export const createProvider = createAction(
  '[Provider] Create Provider',
  props<{ provider: Provider }>()
);

export const updateProvider = createAction(
  '[Provider] Update Provider',
  props<{ provider: Provider }>()
);

export const deleteProvider = createAction(
  '[Provider] Delete Provider',
  props<{ providerId: string }>()
);
